<template>

    <div class="search-contents-wrap _particular">

        <button type="button" class="mobile-back-btn" v-on:click="mobileSearchBack">
            <div class="md_icon-btn _small">
                <div class="inner"><SvgIconBack /></div>
            </div>
            <p>BACK</p>
        </button>

        <div class="scroll-inner">

            <div class="form_checkbox-wrap search-contents-inner">

                <!----------------------------------------------
                    セールス募集
                ------------------------------------------------->
                <!-- BtoB -->
                <ParticularSalesB v-if="$store.state.search.form.shop_user_plan == 11 && !pageShowroom"/>

                <!-- BtoC -->
                <!-- <ParticularSalesC v-if="$store.state.search.form.shop_user_plan == 11"/> -->

                <!----------------------------------------------
                    セールススタイル
                ------------------------------------------------->
                <ParticularSalesStyle v-if="($store.state.search.form.shop_user_plan == 10 || $store.state.search.form.shop_user_plan == 11) && !pageShowroom"/>

                <!----------------------------------------------
                    オーダー
                ------------------------------------------------->
                <ParticularOrder v-if="($store.state.search.form.shop_user_plan == 10 || $store.state.search.form.shop_user_plan == 11) && !pageShowroom"/>


                <!----------------------------------------------
                    お支払い方法
                ------------------------------------------------->
                <ParticularPaymentMethod v-if="($store.state.search.form.shop_user_plan == 10 || $store.state.search.form.shop_user_plan == 11) && !pageShowroom"/>

                <!----------------------------------------------
                    エリアで検索
                ------------------------------------------------->
                <ParticularArea v-if="$store.state.search.form.shop_user_plan == 11 && !pageShowroom"/>

                <!----------------------------------------------
                    ターゲット
                ------------------------------------------------->
                <ParticularTarget />

                <!----------------------------------------------
                    対象店舗
                ------------------------------------------------->
                <ParticularNet v-if="!pageShowroom"/>

                <!----------------------------------------------
                    プライス
                ------------------------------------------------->
                <ParticularPrice />

            </div>
        </div>
    </div>

</template>

<script>

    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'

    //SearchParts
    import ParticularSalesB from '@/components/EndUser/MenuSearchParticularSalesB'
    import ParticularSalesC from '@/components/EndUser/MenuSearchParticularSalesC'
    import ParticularOrder from '@/components/EndUser/MenuSearchParticularOrder'
    import ParticularSalesStyle from '@/components/EndUser/MenuSearchParticularSalesStyle'
    import ParticularPaymentMethod from '@/components/EndUser/MenuSearchParticularPaymentMethod'
    import ParticularArea from '@/components/EndUser/MenuSearchParticularArea'
    import ParticularTarget from '@/components/EndUser/MenuSearchParticularTarget'
    import ParticularNet from '@/components/EndUser/MenuSearchParticularNet'
    import ParticularPrice from '@/components/EndUser/MenuSearchParticularPrice'

    export default {
        components: {
            SvgIconBack,
            ParticularSalesB,
            ParticularSalesC,
            ParticularOrder,
            ParticularSalesStyle,
            ParticularPaymentMethod,
            ParticularArea,
            ParticularTarget,
            ParticularNet,
            ParticularPrice,
        },
        computed: {
            pageShowroom() {
                return location.pathname == '/showroom-list';
            },
        },
        methods: {
            ////////////////////////////////////
            //検索メニューMobile表示Backボタン
            ////////////////////////////////////
            mobileSearchBack: function () {
                this.tabSelectorActive = '';
                for (const element of document.getElementsByName('search-select')) {
                    element.checked = false;
                }
            },
        },
    }
</script>
